module.exports = __WEBPACK_EXTERNAL_MODULE__langchain_openai_98226cd4__;